import type { HTMLAttributes, ReactNode } from 'react';

export interface FormMessageProps extends HTMLAttributes<HTMLParagraphElement> {
  readonly children: ReactNode;
}

/** Erros ficam junto do campo e são anunciados; toasts não substituem a mensagem inline. */
export function FormMessage({ children, className, ...props }: FormMessageProps) {
  const classes = ['ui-form-message'];
  if (className) classes.push(className);
  return <p {...props} className={classes.join(' ')} role="alert">{children}</p>;
}
